import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Uncaught error:", error, errorInfo);
    
    // Lógica de Recuperação Automática para erros de carregamento de bundle (404/HTML no JS)
    const errorMessage = error?.toString().toLowerCase() || "";
    const isChunkError = errorMessage.includes("unexpected token '<'") || 
                         errorMessage.includes("loading chunk") || 
                         errorMessage.includes("load chunk") ||
                         errorMessage.includes("syntaxerror: unexpected token") ||
                         errorMessage.includes("failed to fetch dynamically imported module");

    if (isChunkError) {
      const lastRetry = sessionStorage.getItem('last_chunk_retry');
      const now = Date.now();
      
      // Se não tentou nos últimos 10 segundos, tenta recarregar automaticamente
      if (!lastRetry || (now - parseInt(lastRetry)) > 10000) {
        sessionStorage.setItem('last_chunk_retry', now.toString());
        console.warn("ERROR_BOUNDARY: Detectada falha de bundle. Tentando recarga automática...");
        window.location.reload();
        return;
      }
    }

    this.setState({ errorInfo });
  }

  render() {
    if (this.state.hasError) {
      const errorMessage = this.state.error?.toString() || "";
      const isChunkError = errorMessage.includes("Unexpected token '<'") || 
                           errorMessage.includes("Loading chunk");

      return (
        <div style={{ padding: '20px', fontFamily: 'sans-serif', textAlign: 'center', backgroundColor: '#f9fafb', minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <div style={{ maxWidth: '500px', margin: '0 auto', backgroundColor: 'white', padding: '40px', borderRadius: '16px', boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1)' }}>
            <h1 style={{ color: '#111827', fontSize: '24px', marginBottom: '16px' }}>
              {isChunkError ? "Atualização Necessária" : "Algo deu errado"}
            </h1>
            <p style={{ color: '#4b5563', marginBottom: '24px', lineHeight: '1.5' }}>
              {isChunkError 
                ? "Uma nova versão do app está disponível. Clique abaixo para atualizar."
                : "Ocorreu um erro inesperado. Se o problema persistir, entre em contato com o suporte."}
            </p>
            
            <details style={{ whiteSpace: 'pre-wrap', textAlign: 'left', marginBottom: '24px', backgroundColor: '#f3f4f6', padding: '12px', borderRadius: '8px', fontSize: '12px', color: '#6b7280', maxHeight: '150px', overflowY: 'auto' }}>
              <summary style={{ cursor: 'pointer', marginBottom: '8px', fontWeight: 'bold' }}>Detalhes técnicos</summary>
              {errorMessage}
              <br />
              {this.state.errorInfo && this.state.errorInfo.componentStack}
            </details>

            <button 
              onClick={() => window.location.reload()} 
              style={{ padding: '12px 24px', fontSize: '16px', fontWeight: '600', backgroundColor: '#4f46e5', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', transition: 'background-color 0.2s', width: '100%' }}
              onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#4338ca'}
              onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#4f46e5'}
            >
              {isChunkError ? "Atualizar Agora" : "Tentar Novamente"}
            </button>
          </div>
        </div>
      );
    }

    return this.props.children; 
  }
}

export default ErrorBoundary;
